export default "__VITE_ASSET__gTAV50X2__"